module.exports = {"data":{"site":{"siteMetadata":{"title":"Women World Cup France 2019"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 95
// module chunks = 60335399758886 114276838955818